module.exports = "https://static.zego.com/_next/static/images/Hourly-0d474ec9b36fd4a10b20855d0c23a70b.svg";